import CustomButton from "../CustomButton";
import Icon from "../../../assets/Icon";
import ReactPlayer from "react-player";
import { useState } from "react";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const AppNonIdeal = ({ data }) => {
  const { audioLink, subtitle, onClick, title, image, I18n } = data || {};

  const [playing, setIsPlaying] = useState(false);

  const handlePlay = (play = false) => setIsPlaying(play);
  const handleAction = () => {
    triggerLogEvent(analytics, "non_ideal_cta_clicked");
    handlePlay();
    onClick(true);
  };

  return (
    <div className="appNonIdealMain">
      <div className="appNonIdealHeader">
        <h1 className="fontSize22 darkGrayColor textCapitalize fontWeight400">
          {title}
        </h1>
        <p className="fontSize16 darkGrayTwoColor marginBottom0 marginTop5">
          {subtitle}
        </p>
      </div>
      <div className="appNonIdealBody">
        {image ? (
          <img src={image} style={{ resize: "cover" }} />
        ) : (
          <div className="audioBox">
            <ReactPlayer
              onPlay={() => handlePlay(true)}
              onPause={() => handlePlay()}
              playing={playing}
              url={audioLink}
              height="100%"
              width="100%"
              controls
            />
          </div>
        )}
      </div>
      <div className="appNonIdealFooter">
        <p className="fontSize16 mediumGrayColor marginBottom0">
          {I18n.wasooli_tez_safe}
        </p>
        <p className="fontSize11 mediumGrayColor marginBottom0">
          <span>
            <Icon
              data={{
                viewBox: "0 0 20 23",
                name: "trustIcon",
                fill: "#4AC600",
                height: "23",
                width: "20",
              }}
            />
          </span>
          <span className="marginLeft5">{I18n.trusted_b}</span>
        </p>
        {image ? null : (
          <div className="cell">
            <Icon
              data={{
                name: "downArrowIcon",
                className: "bounce2",
                viewBox: "0 0 19 21",
                fill: "#414143",
                height: "21",
                width: "19",
              }}
            />
          </div>
        )}
      </div>
      {!image && (
        <div className="nonIdealActionButton">
          <CustomButton
            onClick={handleAction}
            type={"primary-new"}
            title={I18n.start}
            loading={false}
            status={false}
          />
        </div>
      )}
    </div>
  );
};

export default AppNonIdeal;
